import { forwardRef, useContext } from "react";

import FinderResultsContext from "context/FinderResultsContext";

import Pagination from "./Pagination";

function listingsHeaderScrollIntoView() {
  const headerMessage = document.getElementById(
    "finder-listings__header-message"
  );
  if (headerMessage) {
    headerMessage.scrollIntoView();
  }
}

const PaginationWithData = forwardRef(() => {
  const { getPage, pageCount, handlePageChange, handleGetPageUrl } =
    useContext(FinderResultsContext);

  const handleSetPage = (value: number) => {
    listingsHeaderScrollIntoView();
    handlePageChange(value);
  };

  return (
    <Pagination
      page={getPage()}
      total={pageCount}
      setPage={handleSetPage}
      getUrl={handleGetPageUrl}
    />
  );
});

export default PaginationWithData;
